<template>
	<div class="v-filemanager">
		<div class="v-filemanager__no-files" v-if="!files.length">
			<p v-html="noFilesMessage"/>
		</div>
		<table class="v-filemanager__table" v-if="files.length">
			<thead>
				<tr>
					<th align="left">File</th>
					<th align="right" class="actions"><span>Actions</span></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(file, fileIndex) in files" :key="fileIndex">
					<th align="left" scope="row" v-html="file.name"/>
					<td align="right">
						<v-contextual>
							<v-contextual-option
								class="button button--primary--small"
								@click="viewFile(file.uri)">View File</v-contextual-option>
							<v-contextual-option
								class="button button--primary--small"
								@click="deleteFile(file)">Delete File</v-contextual-option>
						</v-contextual>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="v-filemanager__uploader">
			<label :for="id" v-html="uploadMessage"/>
			<input type="file" :id="id" :aria-controls="id" :aria-labelledby="id" :accept="accept" :name="id">
			<Dropzone/>
		</div>
	</div>
</template>
<script>
import Dropzone from "../v-dropzone/Dropzone";

export default {
	components: {
		Dropzone,
	},
	props: {
		files: {
			required: true,
			type: Object,
			default() {
				return {};
			}
		},
		post: {
			required: true,
			type: String,
		},
		delete: {
			required: true,
			type: String,
		},
		accept: {
			required: false,
			type: String,
			default() {
				return null;
			}
		},
		noFilesMessage: {
			required: false,
			type: String,
			default() {
				return "No files";
			}
		},
		uploadMessage: {
			required: false,
			type: String,
			default() {
				return "Select or drop files";
			}
		},
	},

	computed: {
		id() {
			return "test";
		}
	},
};
</script>
